<template>
<div id="edit-partner-app">
  <h2>Edit Partner</h2>

  <partner-app-form
    :partnerId="partnerId"
    :partnerAppId="partnerAppId"
  ></partner-app-form>
</div>
</template>

<script>
import PartnerAppForm from '@/components/PartnerAppForm'

export default {
  components: {
    'partner-app-form': PartnerAppForm
  },

  props: ['partnerId', 'partnerAppId'],

  methods: {
    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/PartnerAppEdit.vue